export function BulbIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7 9a5 5 0 118.194 3.847l-.21.175-.827 2.314a1 1 0 01-.941.664H13v-5.586l1.707-1.707a1 1 0 00-1.414-1.414L12 8.586l-1.293-1.293a1 1 0 00-1.414 1.414L11 10.414V16h-.216a1 1 0 01-.941-.664l-.827-2.314-.21-.175A4.988 4.988 0 017 9zm5-7a7 7 0 00-4.687 12.2l.646 1.809A3 3 0 0010.784 18h2.432a3 3 0 002.825-1.991l.646-1.81A7 7 0 0012 2zM9 21a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z"
      ></path>
    </svg>
  );
}
